<template>
  <bootstrap-collapse :visible="visible">
    <b-card-text>
      <b-card-title class="h3 mb-0">Filtro de busca</b-card-title>
      <div class="col-lg-12" style="text-align: right;"></div>
      <small class="text-muted">Defina um ou mais valores para cada filtro</small>

      <b-row>
        <b-col md="6">
            <div class="pt-3 pb-2">Categoria de roteiros:</div>
            <multiselect
                :multiple="true"
                placeholder="Pesquisar..."
                deselect-label="Remover"
                select-label="Adicionar"
                selected-label="Selecionado"
                v-model="selectedInputCategories"
                :options="inputCategories"
                :searchable="false">
            </multiselect>
        </b-col>
      </b-row>
    
    </b-card-text>
  </bootstrap-collapse>
</template>

<script>
import BootstrapCollapse from "@/components/BootstrapCollapse/BootstrapCollapse";
import { Select, Option, Col } from "element-ui";

export default {
  name: "search-filter-operacao",
  
  props: {
    visible: { type: Boolean, default: true },

    inputCategories: {type: Array, default: [] },
  },

  components: {
    BootstrapCollapse,
    [Select.name]: Select,
    [Option.name]: Option,
    [Col.name]: Col
  },

    watch:{
      selectedInputCategories(novo,old){
        this.$emit('categoriesSelected',Object.values(novo))
      },
    },

  data() {
    return {
      selectedInputCategories: [],
    };
  },

  methods: {
  }

};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>

